"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sdg = void 0;
var gql = String.raw;
var React = __importStar(require("react"));
var sdg_icon_1 = require("../../components/entities/sdg-icon");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var lodash_1 = require("lodash");
var graphql_1 = require("../../utils/graphql");
exports.Sdg = {
  name: 'Sdg',
  label: "SDG",
  pluralLabel: "SDGs",
  // useNetwork: true,
  groupName: process.env.TAXONOMIES_LABEL || "Challenges & Goals",
  defaultSortField: 'number',
  includeInSearch: true,
  includeInMetrics: false,
  canEmbed: true,
  useConnections: true,
  useSpaces: true,
  useSlices: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      description { id text }\n      challenges { id }\n      organisations { id }\n      feeds { ...EntityValueFields }\n      videos { ...EntityValueFields }\n\n    "], ["\n      description { id text }\n      challenges { id }\n      organisations { id }\n      feeds { ...EntityValueFields }\n      videos { ...EntityValueFields }\n\n    "])))
  },
  sidebar: {
    queryFields: 'number',
    sort: function (items) {
      return (0, lodash_1.sortBy)(items, 'number');
    },
    label: function (sdg) {
      return "".concat(sdg.number, ". ").concat(sdg.name);
    }
  },
  update: {
    queryFields: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      description { id text }\n    "], ["\n      description { id text }\n    "])))
  },
  form: {
    fields: {
      description: {
        type: 'description'
      },
      image: {
        type: 'image'
      },
      color: {
        type: 'linked',
        entityTypeName: 'Color'
      }
    }
  },
  list: {
    baseState: {
      orderBy: {
        fieldName: "number"
      }
    },
    queryFields: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      number\n      targets { id name slug }\n      challenges { id }\n      organisations { id }\n      description { id text }\n    "], ["\n      number\n      targets { id name slug }\n      challenges { id }\n      organisations { id }\n      description { id text }\n    "]))),
    banner: {
      content: 'Track Stakeholders, Action and Places against the United Nations Sustainable Development Goals.'
    }
  },
  select: {
    canCreate: function () {
      return false;
    },
    queryFields: "number description { id text }",
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        icon: function () {
          return React.createElement(sdg_icon_1.SdgIcon, {
            size: 20,
            entity: entity
          });
        },
        tall: true,
        label: "".concat(entity.name, " (").concat(entity.number, ")")
      });
    }
  }
};
var templateObject_1, templateObject_2, templateObject_3;